import type React from 'react';

export interface CardContentProps {
  children?: React.ReactNode;
}

export const CardContent = ({ children }: CardContentProps) => {
  return <div className="p-2.5 pt-0">{children}</div>;
};
